<template>
    <div class="tree-wrapper" v-if="data && data.length" :style="{height: height}">
        <el-input v-if="filterable" placeholder="请输入关键字进行过滤" v-model="keyword"></el-input>
        <el-scrollbar class="el-tree-wrap" :style="{height: bodyHeight}">
            <el-tree
                :style="{height: '100%'}"
                :data="data"
                ref="tree"
                :empty-text="emptyText"
                :props="options"
                :load="load"
                :lazy="lazy"
                :node-key="nodeKey"
                :highlight-current="highlightCurrent"
                :default-expand-all="defaultExpandAll"
                :show-checkbox="showCheckbox"
                :default-checked-keys="defaultCheckedKeys"
                :default-expanded-keys="defaultExpandedKeys"
                :filter-node-method="__filter"
                :expand-on-click-node="expandOnClickNode"
                :indent="indent"
                :current-node-key="currentNodeKey"
                :accordion="accordion"
                :allowDrag="__allowDrag"
                :allowDrop="__allowDrop"
                :draggable="draggable"
                @current-change="onCurrentChange"
                @node-drag-end="onNodeDropEnd"
                @node-contextmenu="onNodeContextMenu"
                @node-click="onNodeClick"
                @check-change="onCheckChange"
                @check="onCheck"
                @node-expand="onNodeExpand"
                @node-collapse="onNodeCollapse">
                <tree-node slot-scope="{node, data}"
                    :node="node"
                    :data="data"
                    :disabled="isDisabled(node.data)"
                    :options="options"
                    @command="onNodeCommand"
                    v-model="node.data[options.label]"
                    :action-sheet="actionSheet"></tree-node>
            </el-tree>
        </el-scrollbar>
    </div>
</template>

<script>
import TreeNode from './tree-node.vue'
export default {
  name: 'v-tree',
  components: {
    TreeNode
  },
  props: {
    data: { // 展示数据
      type: Array,
      default () {
        return []
      }
    },
    nodeKey: {
      type: String,
      default: 'id'
    },
    emptyText: {
      type: String,
      default: '暂无数据'
    },
    props: { // 配置项
      type: Object,
      default: () => {
        return {}
      }
    },
    height: {
      type: String,
      default: '100%'
    },
    load: Function, // 懒加载函数
    lazy: Boolean, // 是否开启懒加载
    highlightCurrent: { // 是否高亮当前节点
      type: Boolean,
      default: true
    },
    expandOnClickNode: Boolean,
    defaultExpandAll: Boolean, // 是否默认展开所有节点
    showCheckbox: Boolean, // 节点是否可以被选择（多选）
    currentNodeKey: [String, Number], // 当前选中节点key
    defaultCheckedKeys: { // 默认勾选的节点的key数组
      type: Array,
      default () {
        return []
      }
    },
    defaultExpandedKeys: {
      type: Array,
      default () {
        return []
      }
    },
    filterable: { // 是否可过滤（搜索）
      type: Boolean,
      default: true
    },
    filterNodeMethod: Function, // 节点过滤函数
    accordion: Boolean, // 是否每次只打开同一级树节点
    indent: { // 相邻节点间的水平缩颈
      type: Number,
      default: 16
    },
    draggable: { // 是否开启拖拽节点功能
      type: Boolean,
      default: true
    },
    allowDrag: Function, // 节点是否能够被拖拽 Function (node) 默认情况下一级不允许拖拽
    allowDrop: Function, // 节点是否能够被放置，默认情况下只允许同级别的节点被放置
    actionSheet: Array,
    reverse: Boolean
  },
  data () {
    return {
      keyword: '',
      tree: null,
      defaultProps: {
        label: 'label',
        children: 'children',
        disabled: 'disabled',
        isLeaf: 'isLeaf'
      },
      options: {}
    }
  },
  computed: {
    bodyHeight () {
      // 32px + 10px
      if (this.filterable) return `calc(100% - 42px)`
      else return '100%'
    }
  },
  watch: {
    keyword (newVal, oldVal) {
      if (this.$refs.tree && oldVal !== newVal) {
        this.$refs.tree.filter(this.keyword)
      }
    }
  },
  methods: {
    isDisabled (node) {
      if (node[this.options.disabled] === undefined) return false
      return this.reverse ? !node[this.options.disabled] : !!node[this.options.disabled]
    },
    /**
     * @description 获取叶子节点 TODO 适配别名
     * @author yangyu
     */
    getLeaf (values, id) {
      if (!values) return null
      for (let i = 0; i < values.length; ++i) {
        let val = values[i]
        if (val.children && val.children.length) {
          let leaf = this.getLeaf(val.children, id)
          if (leaf) return leaf
        } else {
          if (id !== undefined && val.id == id) {
            return val
          } else if (id === undefined || id === null) return val
        }
      }
      return null
    },
    __initData (data) {
      if (!data) return
      for (let i = 0; i < data.length; ++i) {
        this.$set(data[i], '__edit', false)
        if (data[this.options.children]) this.__initData(data[this.options.children])
      }
    },
    __filter (value, data, node) {
      if (this.filterNodeMethod && typeof this.filterNodeMethod === 'function') {
        return this.filterNodeMethod(value, data, node)
      } else {
        return this.__defaultFilterNodeMethod(value, data)
      }
    },
    __defaultFilterNodeMethod (value, data) {
      if (!value) return true
      return this.props.label ? (typeof this.props.label !== 'function' ? data[this.props.label].indexOf(value) !== -1 : data[this.props.label()].indexOf(value) !== -1
      ) : data.label.indexOf(value) !== -1
    },
    __allowDrag (node) {
      if (this.allowDrag && typeof this.allowDrag === 'function') {
        return this.allowDrag(node)
      } else return this.__defaultAllowDrag(node)
    },
    __defaultAllowDrag (node) {
      // 默认情况下，一级节点不允许拖拽
      return true // node.level !== 1
    },
    __allowDrop (draggingNode, dropNode, type) {
      if (this.allowDrop && typeof this.allowDrop === 'function') {
        return this.allowDrop(draggingNode, dropNode, type)
      } else return this.__defaultAllowDrop(draggingNode, dropNode, type)
    },
    __defaultAllowDrop (draggingNode, dropNode, type) {
      // 默认情况下，不允许非同级元素交换顺序且不允许交换到下级，并且限制在同一个层级下
      // return true
      return draggingNode.level === dropNode.level && draggingNode.parent === dropNode.parent && type !== 'inner'
    },
    onNodeCommand (command, current) {
      this.$emit('command', command, current)
    },
    onCurrentChange (data, node) {
      // 叶子节点
      let leaf = !data[this.options.children] || !data[this.options.children].length ? node : null
      this.$emit('current-change', data, node, leaf)
    },
    onNodeDropEnd (prev, next, type, e) {
      if (next) {
        // 如果后台需要改变节点顺序，那么可以通过next.parent.children获取到拖拽后的节点
        let currentNodes = next && next.parent && next.parent.data && next.parent.data.children || []
        this.$emit('node-drop-success', prev, next, type, e, currentNodes)
      } else {
        this.$emit('node-drop-failed', prev, type, e)
      }
    },
    onNodeClick (o, node, vm) {
      this.$emit('node-click', o, node, vm)
    },
    onNodeContextMenu (e, o, node, vm) {
      this.$emit('node-contextmenu', e, o, node, vm)
    },
    onCheckChange (o, checked, childrenChecked) {
      this.$emit('check-change', o, checked, childrenChecked)
    },
    onCheck (node, state) {
      this.$emit('check', node, state)
    },
    onNodeExpand (o, node, vm) {
      this.$emit('node-expand', o, node, vm)
    },
    onNodeCollapse (o, node, vm) {
      this.$emit('node-collapse', o, node, vm)
    },
    getCurrentNode () {
      // element ui bug???
      if (!this.$refs.tree) return
      let nodeData = this.$refs.tree.getCurrentNode()
      if (nodeData) {
        return this.getNode(nodeData[this.nodeKey])
      }
      return null
    },
    getNode (key) {
      return this.$refs.tree.getNode(key)
    },
    setCurrentKey (nodeKey) {
      if (this.$refs.tree) this.$refs.tree.setCurrentKey(nodeKey)
    },
    /**
     * @description 追加节点，不能添加新的根节点，想要添加新的根节点可以通过直接改变data做到
     * @param {Object} node 父节点
     * @param {Object} newNode 新节点
     */
    append (node, newNode) {
      if (node && node.data && node.data.children && newNode) {
        node.data.children.push(newNode)
      } else if (node && node.data && newNode) {
        this.$set(node.data, 'children', [newNode])
      }
    },
    /**
     * @description 移除节点
     * @param {Object} node 待移除的节点
     */
    remove (node) {
      if (node) {
        const parent = node.parent
        const data = node.data
        const children = parent.data.children || parent.data
        const index = children.findIndex(d => d[this.nodeKey] === data[this.nodeKey])
        children.splice(index, 1)
      }
    },
    onClick (node) {
      node.data.__edit = true
    },
    setCheckedKeys (keys, leafOnly) {
      if (this.$refs.tree) this.$refs.tree.setCheckedKeys(keys, leafOnly)
    }
  },
  mounted () {
    this.options = Object.assign({}, this.defaultProps, this.props)
    this.tree = this.$refs.tree
  }
}
</script>

<style lang="less">
.tree-wrapper {
    background: #fff;
    .el-input {
        margin-bottom: 10px;
    }
    .el-tree-wrap {
      overflow-x: hidden;
      .el-scrollbar__wrap {
        overflow-x: hidden;
      }
      .el-scrollbar__bar {
        display: none;
      }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/framework/tree/tree.vue